export default "__VITE_ASSET__DD76aLms__"